/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 */

export class ScrollToNextSection {
    constructor() {
        const domElements = document.querySelectorAll('.js__scroll-to-next-section')
        domElements.forEach((element) => {
            element.addEventListener('click', () => {
                const currentSection = element.closest('section')
                const nextSection = currentSection.nextElementSibling
                if (nextSection) {
                    nextSection.scrollIntoView()
                }
            })
        })
    }
}
